<template>
  <div class="one-screen">
    <div class="one-screen__inner">
      <v-card :class="rightToLefttAnimation?'':'reverse'">
        <a v-if="hasBackPath" @click="goBack()" class="one-screen__back-link">
          <v-icon small>keyboard_backspace</v-icon>
          <span>
            {{ backTitle }}
          </span>
        </a>
        <customTransition mode="out-in">
          <component
           ref="content"
           :is="curComponent"
           :mode="leadId==null?'start':'continue'"
           @height-calculated="onHeightCalculated"
           @route-to-next-slide="onNextRouteNavigate"
           :UIComponentData="curUIData"
           :UIId="curUIId"
          ></component>
        </customTransition>
      </v-card>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters,mapActions } from 'vuex';
import steps from '@/components/steps';
import * as questionnaireService from '@/services/questionnaire.service';
import { createSimpleTransition } from 'vuetify/lib/components/transitions/createTransition'
const myTransition = createSimpleTransition('customTransition')
Vue.component('customTransition', myTransition)

export default {
  name: "one-screen",
  components: {},
  data: () => ({
    backPath: "",
    contentHeight: 0,
    headerHeight: 0,
    footerHeight: 0,
    transitionName: "",
    prevRoute: "",
    curRoute:null,
    leadId:null,
    isBackRoute:false,
    backTitle:"PREVIOUS STEP",
    rightToLefttAnimation:true
  }),
  computed: {
    ...mapGetters(['questionnaireLead','curMode','curLeadWizard']),
    innerStyle() {
      return {
        minHeight: `${this.contentHeight + 200}px`,
        height:
          window.innerHeight > this.contentHeight
            ? `calc( 100vh - ${this.headerHeight + this.footerHeight}px)`
            : "auto",
      };
    },
    curComponent(){
      return this.curRoute==null?'':steps[this.curRoute.Component]
    },
    curUIData(){
      return this.curRoute==null?null:this.curRoute.UIComponents
    },
    curUIId(){
      return this.curRoute==null?null:this.curRoute.Id
    },
    hasBackPath(){
      return this.curRoute!=null && this.curRoute.Id>1
    },
    addLeadSlideId() {
      if(this.curLeadWizard && this.curLeadWizard.LeadTemplate && this.curLeadWizard.LeadTemplate.Slides){
        let addLeadSlide = this.curLeadWizard.LeadTemplate.Slides.find(x=>x.AddLead === true)
        if(addLeadSlide != null){
          return addLeadSlide.Id
        }
      }
      return null
    }
  },
  methods: {
    ...mapActions(['getLead','updateLead','addLead', 'mutateLead']),
    emitGoogleTagEvent(){
      if(this.curRoute.GoogleTag!=null){
        this.$gtag.event('conversion', {
          'send_to': this.curRoute.GoogleTag,
          'value': 1.0,
          'currency': 'USD',
          'aw_remarketing_only': true
        })
      }

    },
    async onNextRouteNavigate(emitGoogleTagEvent){
      if(emitGoogleTagEvent){
        this.emitGoogleTagEvent();
      }
      if (this.addLeadSlideId === this.curRoute.Id) {
        this.$root.$emit("updatingDataStarted")
        if (!this.questionnaireLead.LeadId) {
          await this.addLead(this.questionnaireLead);
        }
        else{
          await this.updateLead(this.questionnaireLead);
        }
        this.$root.$emit("updatingDataEnded")
      }
      else if(this.curRoute.Id > this.addLeadSlideId){
        this.$root.$emit("updatingDataStarted")
        await this.updateLead(this.questionnaireLead);
        this.$root.$emit("updatingDataEnded")
      }
      this.rightToLefttAnimation=true
      let routeId=this.curRoute.Id + 1;
      let pageId = this.curMode == 1 ? parseInt(questionnaireService.getPageId()) : NaN
      if(!isNaN(pageId) && this.curRoute.Id==0){
        routeId=pageId
      }
      let route=this.curLeadWizard.LeadTemplate.Slides.find(x=>x.Id==routeId)
      if(route==null){
        questionnaireService.destroyPageId()
        questionnaireService.destroyLeadId()
        questionnaireService.destroyWizardId()
        if(this.curLeadWizard!=null){
          if (window.self !== window.top) {
            window.parent.location.href = this.curLeadWizard.LeadTemplate.RedirectUrl+`?leadID=${this.questionnaireLead.LeadId}`;
          } else {
            window.location.href = this.curLeadWizard.LeadTemplate.RedirectUrl+`?leadID=${this.questionnaireLead.LeadId}`;
          }
          return
        }
        else{
        route=this.curLeadWizard.LeadTemplate.Slides.find(x=>x.Id==0)
        this.$router.push('/'+route.RouteName);
        }
        return
      }
      while(!this.isConditionValid(route)){
        routeId++;
        route=this.curLeadWizard.LeadTemplate.Slides.find(x=>x.Id==routeId)
      }
      this.leadId = questionnaireService.getLeadId()
      if((isNaN(pageId) || pageId<routeId) && this.leadId!=null && this.curMode==1){
        questionnaireService.savePageId(routeId)
      }
      this.$router.push('/'+route.RouteName);
    },
    onHeightCalculated() {
      this.updateContentHeight();
    },
    goBack() {
      this.rightToLefttAnimation=false
      let routeId=this.curRoute.Id - 1;
      let route=this.curLeadWizard.LeadTemplate.Slides.find(x=>x.Id==routeId)
      while(!this.isConditionValid(route)){
        routeId--;
        route=this.curLeadWizard.LeadTemplate.Slides.find(x=>x.Id==routeId)
      }
      this.$router.push('/'+route.RouteName);
    },
    updateContentHeight() {
      if(this.$refs.content==null)
        return
      const currentHeight = this.$refs.content.$el.clientHeight;
      if (this.contentHeight !== currentHeight) {
        this.contentHeight = currentHeight;
      }
    },
    processRoute(to){
      if(this.curLeadWizard.LeadTemplate==null)
        return
      this.curRoute=this.curLeadWizard.LeadTemplate.Slides.find(x=>('/'+x.RouteName)===to.path);
      if(this.curRoute==null){
        this.curRoute=this.curLeadWizard.LeadTemplate.Slides.find(x=>x.Id==0)
        this.$router.push('/'+this.curRoute.RouteName);
        return
      }
      this.leadId = questionnaireService.getLeadId()
      if(this.curRoute.Id!=0){
        let pageId = this.curMode == 1 ? parseInt(questionnaireService.getPageId()) : this.curRoute.Id
        if(pageId<this.curRoute.Id && this.leadId!=null){
          let newRoute=this.curLeadWizard.LeadTemplate.Slides.find(x=>x.Id==pageId)
          this.$router.push('/'+newRoute.RouteName);
        }
        if(!this.isConditionValid(this.curRoute)){
          let routeId=this.curRoute.Id - 1;
          let route=this.curLeadWizard.LeadTemplate.Slides.find(x=>x.Id==routeId)
          while(!this.isConditionValid(route)){
            routeId--;
            route=this.curLeadWizard.LeadTemplate.Slides.find(x=>x.Id==routeId)
          }
          this.$router.push('/'+route.RouteName);
        }
      }
    },
    isConditionValid(curRoute){
      if(!curRoute.Present)
        return false
      if(curRoute.Condition!=null && curRoute.Condition!='All'){
        if(Array.isArray(curRoute.Condition)){
          for(var i=0;i<curRoute.Condition.length;i++){
            if(!this.checkCondition(curRoute.Condition[i])){
              return false
            }
          }
        }
        else{
          return this.checkCondition(curRoute.Condition)
        }
      }
      return true
    },
    checkCondition(condition){
      let conditionArgs=condition.split('=')
      return this.questionnaireLead[conditionArgs[0]] !=null && (this.questionnaireLead[conditionArgs[0]]).toString()==conditionArgs[1]
    }
  },
  async mounted() {
    this.updateContentHeight();
    this.headerHeight = this.$refs.header
      ? this.$refs.header.$el.offsetHeight
      : 0;
    this.footerHeight = this.$refs.footer
      ? this.$refs.footer.$el.offsetHeight
      : 0;
    this.processRoute(this.$route)
  },
  watch: {
    $route(to) {
      this.processRoute(to)
    },
    curLeadWizard(){
      this.processRoute(this.$route)
    }
  },
  async created(){
    const leadId = questionnaireService.getLeadId()
    if(leadId!=null){
      const response = await this.getLead(leadId)
      const cachedLead = response && response.data ? response.data.Data : null

      if(!cachedLead || !cachedLead.LeadId){
        questionnaireService.destroyLeadId()
        questionnaireService.destroyPageId()
        this.leadId = null
        this.mutateLead({ Language: 'en-US' })
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./node_modules/vuetify/src/styles/settings/_variables.scss";
@import "~@/styles/variables";
@import "~@/styles/mixins";
.one-screen {
  min-height: 100%;

  &__inner {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    min-height: 100vh;
    .v-card {
      margin: 30px 10px;

      .customTransition {
        &-enter-active,
        &-leave-active {
          transition: $primary-transition !important;
        }

        &-move {
          transition: transform .6s;
        }

        &-enter, &-leave-to {
          opacity: 0;
        }

        &-enter {
          transform: translateX(15px);
        }

        &-leave-to {
          transform: translateX(-15px);
        }
      }
      &.reverse{
        .customTransition {

          &-enter, &-leave-to {
            opacity: 0;
          }

          &-enter {
            transform: translateX(-15px);
          }

          &-leave-to {
            transform: translateX(15px);
          }
        }
      }
    }
  }

  & &__back-link {
    cursor: pointer;
    position: absolute;
    left: 0;
    top: -25px;
    i {
      color: $link-grey;
    }

    & {
      text: {
        transform: uppercase;
        decoration: none;
      }
      font: {
        family: "Roboto";
        weight: 500;
        size: 14px;
      }
      color: $link-grey;
      letter-spacing: 1.5px;

      span {
        vertical-align: middle;
      }

      &:hover {
        color: $link-grey;
      }
    }
  }
}

</style>
